export const CUSTOMER_TYPE_OPTIONS = [
  { value: 'privat', labelKey: 'private_person', de: 'Privatperson', en: 'Private person' },
  { value: 'freelancer', labelKey: 'freelancer', de: 'Freiberuflich', en: 'Freelancer' },
  { value: 'einzelunternehmen', labelKey: 'sole_proprietor', de: 'Einzelunternehmen', en: 'Sole proprietorship' },
  { value: 'kapitalgesellschaft', labelKey: 'german_corporation', de: 'Deutsche Gesellschaft', en: 'German corporation' },
  { value: 'verein', labelKey: 'association', de: 'Verein', en: 'Association' },
  { value: 'ausland', labelKey: 'foreign_company', de: 'Ausländisches Unternehmen', en: 'Foreign company' },
  { value: 'gruendung', labelKey: 'planned_founding', de: 'Gründung geplant', en: 'Planned founding' },
];

export const CAPITAL_LEGAL_FORMS = ['UG', 'GmbH', 'AG', 'GmbH & Co. KG', 'KG', 'OHG', 'e.K.'];
export const ASSOCIATION_STATUSES = [
  { value: 'e. V.', labelKey: 'association_status_registered', de: 'Eingetragener Verein (e. V.)', en: 'Registered association' },
  { value: 'Verein gegründet – Eintragung beantragt', labelKey: 'association_status_registration_pending', de: 'Eintragung beantragt', en: 'Registration pending' },
  { value: 'Nicht eingetragener Verein', labelKey: 'association_status_unregistered', de: 'Nicht eingetragener Verein', en: 'Unregistered association' },
  { value: 'Vereinsgründung geplant', labelKey: 'association_status_planned', de: 'Vereinsgründung geplant', en: 'Association founding planned' },
];

export function normalizeCustomerType(value) {
  const normalized = String(value || '').trim().toLowerCase();
  if (['freelancer', 'freiberufler', 'freiberuflich', 'freiberuflerin'].includes(normalized)) return 'freelancer';
  if (['einzelunternehmen', 'einzelunternehmer', 'gewerbe', 'sole_proprietor', 'sole-proprietor'].includes(normalized)) return 'einzelunternehmen';
  if (['kapitalgesellschaft', 'deutsche kapitalgesellschaft', 'deutsche_kapitalgesellschaft', 'unternehmen', 'firma', 'gmbh', 'ug', 'ag'].includes(normalized)) return 'kapitalgesellschaft';
  if (['verein', 'e.v.', 'e. v.', 'ev', 'eingetragener verein'].includes(normalized)) return 'verein';
  if (['ausland', 'ausländisch', 'auslaendisch', 'foreign', 'foreign_company', 'nicht_deutsch', 'nicht-deutsch'].includes(normalized)) return 'ausland';
  if (['gruendung', 'gründung', 'in-gruendung', 'in_gruendung', 'gruendung_geplant', 'gründung geplant'].includes(normalized)) return 'gruendung';
  return 'privat';
}

export function companyFieldRules(customerType, legalForm = '') {
  const type = normalizeCustomerType(customerType);
  const association = type === 'verein';
  const registeredAssociation = association && legalForm === 'e. V.';
  return {
    type,
    showCompanyName: type !== 'privat',
    showLegalForm: ['kapitalgesellschaft', 'verein', 'ausland'].includes(type),
    showRepresentative: ['kapitalgesellschaft', 'verein', 'ausland', 'gruendung'].includes(type),
    showBusinessActivity: type !== 'privat',
    showAddress: association || type === 'ausland',
    showRegister: type === 'kapitalgesellschaft' || type === 'ausland' || (association && legalForm !== 'Vereinsgründung geplant'),
    showFoundationDate: type === 'gruendung' || (association && !registeredAssociation),
    evidenceRequired: ['einzelunternehmen', 'kapitalgesellschaft', 'verein', 'ausland'].includes(type),
  };
}

export function evidenceLabel(customerType, legalForm = '') {
  const type = normalizeCustomerType(customerType);
  if (type === 'einzelunternehmen') return 'Gewerbeanmeldung';
  if (type === 'kapitalgesellschaft') return 'Handelsregisterauszug / Unternehmensnachweis';
  if (type === 'verein') return legalForm === 'e. V.' ? 'Vereinsregisterauszug' : 'Satzung / Gründungsnachweis';
  if (type === 'ausland') return 'Registerauszug / Unternehmensnachweis';
  return 'Unternehmensnachweis';
}
